/*-------------------------------------------------------
 The following JavaScript functions control booking basket
---------------------------------------------------------*/

var TECL_UserAccount = {

    // Save the notifications
    SaveNotificationSettings: function( returnUrl ) {
        $("#userAccountSaveSuccess").addClass("hidden");
        $("#userAccountErrorAlert").addClass("hidden");
        var settings = TECL_UserAccount.GetNotificationSettingsData();

        CallServer({
            key: "TECL_UserAccount.SaveNotificationSettings",
            controller: "WebAccountSurface",
            action: "SaveUserNotificationSettings",
            data: {
                settings: settings
            },
            error: function(err) {
                $("#userAccountErrorAlert").html("Unknown error");
                $("#userAccountErrorAlert").removeClass("hidden");
            }, 
            success: function(result) {
              if (result) {
                    $("#userAccountSaveSuccess").html("Saved");
                    $("#userAccountSaveSuccess").removeClass("hidden");

                    if (returnUrl) {
                      window.document.location = returnUrl;
                    } else {
                      setTimeout(function() {
                        $("#userAccountSaveSuccess").html("");
                        $("#userAccountSaveSuccess").addClass("hidden");
                      }, 6000);
                    }
                } else {
                    $("#userAccountErrorAlert").html("Failed to save");
                    $("#userAccountErrorAlert").removeClass("hidden");
                }
            }
        });
    },

    // Get the data from the notifications settings page
    GetNotificationSettingsData: function() {

        var settings = [];
        $("#ChangeAccountSettings").find("[name='tagCheckbox']").each(function() {
            var tagContainerId = $(this).attr("data-TagContainerId");
            var tagId = $(this).attr("data-TagId");
            var selected = $(this).is(":checked");

            if (tagContainerId && tagId) {
                settings.push({
                    TagContainerId: tagContainerId,
                    TagId: tagId,
                    Selected: selected,
                    Name: ""
                });
            }
        });
        return settings;
    }

}
